import { deleteRequest, getFileRequest, getImageRequest, postRequest, putRequest, RequestDataType } from "services/api"
import { CreateAsset } from "../models/asset-models"

export const postNewAsset = async (data: Partial<CreateAsset>) => await postRequest("/assets", data, RequestDataType.FormData)

export const editAsset = async (data: Partial<CreateAsset>) => await putRequest("/assets", data, RequestDataType.FormData)

export const deleteAsset = async (assetId: string) => await deleteRequest("/assets", assetId)

export const getAssetImage = async (assetId: string) => await getImageRequest(`/assets/${assetId}`)

export const getAsset3DFile = async (assetId: string) => await getFileRequest(`/assets/Get3DFile${assetId}`)
